/* eslint-disable */
import { createSelector } from 'reselect';
import { storeActive as storeActiveSelector } from 'ggApp/modules/store/selectors';
import { MODULE_NAME } from '../constants';
import { isShippingAvailableForCountry } from '../utils';

export const moduleState = state => state[MODULE_NAME];
export const countryList = createSelector(
    moduleState,
    state => state.list,
);

export const shippindAvailableCountryList = createSelector(
    countryList,
    fullCountryList => fullCountryList.filter(isShippingAvailableForCountry),
);

export const currentStoreCountrySelector = createSelector(
    countryList,
    storeActiveSelector,
    (fullCountryList, currentStore) => {
        const { country_id: storeCountryId } = currentStore;
        return fullCountryList.filter(({ id }) => id === storeCountryId);
    },
);
